import { Injectable } from '@angular/core';
declare let THREE: any;

@Injectable()
export class ObjectInWallRangev2 {
    protected matrix: any;
    protected wallBoxExpand: any;
    protected wallBox: any;

    protected objectBox: any;
    protected objectBoxCenter: any;
    protected objectBoxSize: any;

    constructor() {
        this.matrix = new THREE.Matrix4();

        this.wallBoxExpand = new THREE.Vector3();
        this.wallBox = new THREE.Box3();

        this.objectBox = new THREE.Box3();
        this.objectBoxCenter = new THREE.Vector3();
        this.objectBoxSize = new THREE.Vector3();
    }

    check(wall, entity, newPosition, rotation) {

        this.wallBoxExpand.set(0, 0, entity.width * 2);

        if (!wall.geometry.boundingBox)
            wall.geometry.computeBoundingBox();

        this.wallBox.copy(wall.geometry.boundingBox);
        this.wallBox.expandByVector(this.wallBoxExpand);
        this.wallBox.applyMatrix4(wall.matrixWorld);

        this.matrix.identity();
        this.matrix.makeRotationFromEuler(rotation);
        this.matrix.setPosition(newPosition);

        this.objectBoxSize.set(entity.length, entity.height, 1);
        this.objectBox.setFromCenterAndSize(this.objectBoxCenter, this.objectBoxSize);
        this.objectBox.applyMatrix4(this.matrix);

        return this.wallBox.containsBox(this.objectBox);
    }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/Drag/Class/object-in-wall-rangev2.ts